export enum LoaderTypeEnum {
  NONE = 0
}
